import OSGStatementsPage from "components/pages/OSGStatementsPage";

export default function CaptureOSGStatements(props) {
    return <OSGStatementsPage />
}